import { render, staticRenderFns } from "./ReportMedicalProblem.vue?vue&type=template&id=1c10e8da&scoped=true&"
import script from "./ReportMedicalProblem.vue?vue&type=script&lang=js&"
export * from "./ReportMedicalProblem.vue?vue&type=script&lang=js&"
import style0 from "./ReportMedicalProblem.vue?vue&type=style&index=0&id=1c10e8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c10e8da",
  null
  
)

export default component.exports